import React, { createContext, useState, useEffect } from 'react';
import { auth } from '../firebase/firebase.js';
import { onAuthStateChanged, signOut } from 'firebase/auth';

export const AuthContext = createContext({
  user: null,
  token: null,
  loading: true,
  isAdminAuthenticated: false,
  setIsAdminAuthenticated: () => {},
  logout: () => {},
  adminLogout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [token, setToken]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdminAuthenticated, setIsAdminAuthenticatedState] = useState(
    () => sessionStorage.getItem('adminAuthenticated') === 'true'
  );

  const setIsAdminAuthenticated = (value) => {
    setIsAdminAuthenticatedState(value);
    if (value) {
      sessionStorage.setItem('adminAuthenticated', 'true');
    } else {
      sessionStorage.removeItem('adminAuthenticated');
    }
  };

  useEffect(() => {
    try {
      const unsubscribe = onAuthStateChanged(auth, async fbUser => {
        if (fbUser) {
          setUser(fbUser);
          try {
            const freshIdToken = await fbUser.getIdToken(true);
            setToken(freshIdToken);
          } catch (e) {
            console.warn('Could not get token:', e);
          }
        } else {
          setUser(null);
          setToken(null);
        }
        setLoading(false);
      });
      return () => unsubscribe();
    } catch (error) {
      console.warn('Firebase auth not configured:', error);
      setLoading(false);
    }
  }, []);

  const logout = () => {
    try {
      return signOut(auth);
    } catch (e) {
      console.warn('Logout error:', e);
    }
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminAuthenticated');
    setIsAdminAuthenticatedState(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        isAdminAuthenticated,
        setIsAdminAuthenticated,
        logout,
        adminLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
